import * as React from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import common from "@material-ui/core/colors/common";
const SortIcon = props => {
  if (props.asc === "asc") {
    return /*#__PURE__*/React.createElement(ExpandLess, {
      focusable: "focusable",
      color: common.white,
      "data-testid": "sort-asc"
    });
  }
  return /*#__PURE__*/React.createElement(ExpandMore, {
    focusable: "focusable",
    color: common.white,
    "data-testid": "sort-desc"
  });
};
export default SortIcon;